import _Abstract from "system/abstract"

const HammerJS = require(`vendor/hammerjs`);

export default class Module_Carousel extends _Abstract {

	constructor(el, options) {
		super(el, $.extend(true, {}, options), 'module')
		this.initModule();
	}

	/********* Initialising ***************/
	initModule()
	{
		if(this.$el.hasClass("-with-description-block"))
		{
			// this.$el.wrap("<div class='m-carousel-wrap'></div>");
			this.$el.addClass("-one-col-right-offset");
		}
		// m-carousel  -with-description-block


		this.$imageSliderContainer = this.$el.find(".c-image-slider");
		if(!this.$imageSliderContainer.length)
		{
			console.log("No instances of image Slider Container Found");
			return;
		}

		this.m_bIsTextUnderneathCarousel = this.$el.hasClass("-with-description-underneath-block");
		this.checkSpacingForCTAs();
		this.swipedBeforeClick = false;
		this.$imageSliderUL = this.$imageSliderContainer.find("ul");
		this.$imageSliderUL.find("> li").removeClass("-hide");

		if(!this.$imageSliderUL.find("> li").length)
		{
			console.log("No Items able to be used for carousel");
			return;
		}

		this.initialiseImageReverseIfDefined();
		this.initialiseNavigationDots();
		this.$carouselCircleContainer = this.$el.find(".c-carousel-circle-ctn");
		this.$carouselCircles = this.$carouselCircleContainer.find(".c-carousel-circle");



		if(this.getTotalSlides() === 1)
		{
			this.$el.find(".c-image-slider-navigate-btn").remove();
			this.$carouselCircleContainer.remove();
			this.$el.addClass("-no-slide");
		}
		else
		{
			if(this.$el.hasClass("-reverse"))
			{
				this.activateCarouselIndex(this.getTotalSlides()-1,false);//Just to make sure everything has the right class etc
			}
			else
			{
				this.activateCarouselIndex(0,false);//Just to make sure everything has the right class etc
			}
			
			this.initialiseHammer();
			this.initListeners();
			// this.rePositionSliderButtonsIfNeeded();
		}

		this.onWindowResize();

	}

	initialiseHammer()
	{
		if(typeof Hammer === "undefined" || typeof Hammer.Manager !== "function")
		{
			console.log("Failed to initialise Carousel Module with Swipe detection due to no Hammer.js, please make sure you have this installed to support swipe gestures");
			return;
		}

		var hammerOptions = {
			touchAction:'auto' //Enables vertical scrolling, as sometimes the carousel fills the whole screen, and the user cant scroll down the page!
		};

		this.hammer = new Hammer.Manager(this.$imageSliderContainer[0],hammerOptions);
		var hammerSwipe = new Hammer.Swipe();
		this.hammer.add(hammerSwipe);
	}

	initListeners()
	{
		this.$el.find(".c-carousel-circle-ctn").on("click","li",(e) => this.onCircleContainerClicked(e));

		this.$el.on("click",".c-image-slider-navigate-btn-ctn .c-image-slider-navigate-btn.-back", (e) => this.onNavigateBackClicked());
		this.$el.on("click",".c-image-slider-navigate-btn-ctn .c-image-slider-navigate-btn.-next", (e) => this.onNavigateNextClicked());

		this.hammer.on('swipeleft', () => this.onSwipeLeft());
		this.hammer.on('swiperight', () => this.onSwipeRight());

		$(window).resize(() => this.onWindowResize());
		this.$el.find(".c-image-slider").on("click","> ul > li [data-tap-through-url]",(e) => this.onLiTileClicked(e));
	}


	onLiTileClicked(e)
	{
		if(this.swipedBeforeClick)
		{
			this.swipedBeforeClick = false;
			return;
		}

		//Internet explorer has issues with an a tag around a carousel item (and using hammer js)
		//So we'll just use a data tag to decide where to navigate to
		var tapThroughURL = $(e.currentTarget).data("tap-through-url");

		if(!tapThroughURL)
		{
			return;
		}

		window.location = tapThroughURL;
	}

	checkSpacingForCTAs()
	{
		var numCTAs = this.$el.find(".c-image-slider-cta").length;
		if(numCTAs)
		{
			return;
		}

		this.$el.addClass("no-ctas");
	}

	initialiseNavigationDots()
	{
		if(this.$el.find(".c-carousel-circle-ctn").length)
		{
			return;
		}


		var carouselCircleHTML = this.getCarouselCircleHTML();

		this.$el.append(carouselCircleHTML);
	}

	initialiseImageReverseIfDefined()
	{
		if(!this.$el.hasClass("-reverse"))
		{
			return;
		}

		this.reverseCarouselItems();
	}

	reverseCarouselItems()
	{
		var $imageSliderUL = this.$imageSliderUL;
		$imageSliderUL.children().each(function()
		{
			$imageSliderUL.prepend(this);
		});
	}

	getCarouselCircleHTML()
	{
		var html = "";
			html += '<div class="content-margin  -hide-for-print">';
			html += '	<ul class="c-carousel-circle-ctn">';

			var numCarouselItems = this.getTotalSlides();
			for(var i = 0; i < numCarouselItems; ++i)
			{
				var classes = "";
				if(i === 0)
				{
					classes += " -active ";
				}
				html += '		<li><div class="c-carousel-circle '+classes+'"></div></li>';
			}
			html += '	</ul>';
			html += '</div>';

			return html;
	}

	/********* Responding to Events ***************/

	onWindowResize()
	{

		this.rePositionSliderButtonsIfNeeded();
		this.reAlignSlides();

	}

	rePositionSliderButtonsIfNeeded()
	{
		if(!this.m_bIsTextUnderneathCarousel)
		{
			return;
		}

		// if()

		var desktopBreakpointSize = $("#bp-desktop").width();
		var bDesktop = $(window).outerWidth() >= desktopBreakpointSize;
		var $tiles = this.$el.find(".c-image-slider > ul .c-tile");
		$tiles.removeAttr("style");
		if(bDesktop)
		{
			
			var currentTileHeight = $tiles.height();
			var width = currentTileHeight * 1.54;
			$tiles.css({width:width});
			this.$el.find(".c-image-slider > ul > li").css({width:width});

			var ulHeight = $(".-with-description-underneath-block .c-image-slider .c-tile ").height()
			var marginTop = parseInt($(".-underneath-carousel-block").css("margin-top"));
			this.$carouselCircleContainer.css({top: ulHeight + marginTop + "px"});
		}
		else
		{
			this.$el.find(".c-image-slider > ul > li").removeAttr("style");
			this.$carouselCircleContainer.removeAttr("style");

			var cTileHeight = this.$el.find(".c-tile").height();

			this.$carouselCircleContainer.css({top:cTileHeight + "px", position: "absolute"})

		}

	}

	onNavigateBackClicked()
	{
		this.onSlideCarouselLeft();
	}

	onNavigateNextClicked()
	{
		this.onSlideCarouselRight();
	}

	onSwipeLeft()
	{
		this.swipedBeforeClick = true;
		console.log("swipe left");
		this.onSlideCarouselRight();
	}

	onSwipeRight()
	{
		this.swipedBeforeClick = true;
		console.log("swipe right");
		this.onSlideCarouselLeft();
	}

	onCircleContainerClicked(_mouseEvent)
	{

		var $currentTarget = $(_mouseEvent.currentTarget);
		var carouselButtonIndex = $currentTarget.index();
		this.activateCarouselIndex(carouselButtonIndex);
	}


	/********* Changing or reading carousel state ***************/

	reAlignSlides()
	{
		var animateRealignment = false;
		this.activateCarouselIndex(this.getCurrentCarouselIndex(),animateRealignment);
	}

	getTotalSlides()
	{
		// var totalSlides = this.$carouselCircles.length;
		var totalSlides = this.$imageSliderUL.find("> li:not(.-faker)").length;
		return totalSlides;	
	}

	getCurrentCarouselIndex()
	{
		// var carouselIndex = this.$el.find(".c-carousel-circle.-active").parent().index();
		var carouselIndex = -1;
		var activeCarouselIndex = -1;
		this.$imageSliderUL.find("> li").each(function(){
			if($(this).hasClass("-faker"))
			{
				return;
			}
			++carouselIndex;

			if($(this).hasClass("-active"))
			{
				activeCarouselIndex = carouselIndex;
				return false;
			}
		});


		// var carouselIndex = this.$imageSliderUL.find("> li.-active").index();
		return activeCarouselIndex;
	}

	onSlideCarouselRight()
	{
		var goToIndex = this.getCurrentCarouselIndex()+1;
		if(goToIndex >= this.getTotalSlides())
		{
			goToIndex = 0;
		}

		this.activateCarouselIndex(goToIndex);
	}

	onSlideCarouselLeft()
	{
		var goToIndex = this.getCurrentCarouselIndex()-1;
		if(goToIndex < 0)
		{
			goToIndex = this.getTotalSlides()-1;
		}

		this.activateCarouselIndex(goToIndex);
	}

	activateCarouselIndex(_index, _animateAlignment)
	{
		if(typeof _animateAlignment === "undefined")
		{
			_animateAlignment = true;
		}

		this.$carouselCircles.removeClass("-active");
		this.$carouselCircles.eq(_index).addClass("-active");

		var $carouselSliderLiItems = this.$imageSliderUL.find("> li:not(.-faker)");
		var $activeCarouselItem = $carouselSliderLiItems.eq(_index);

		if(!$activeCarouselItem.length)
		{
			return;
		}

		$carouselSliderLiItems.removeClass("-active");
		$activeCarouselItem.addClass("-active");

		var carouselWidth = this.$el.width();
		// var offsetWidthOriginal = carouselWidth*_index;
		var offsetWidth = $activeCarouselItem.position().left;
		this.$imageSliderUL.stop(true);

		var cssOffsetObject = {left:-offsetWidth + "px"};
		if(_animateAlignment)
		{
			this.$imageSliderUL.animate(cssOffsetObject);
		}
		else
		{
			this.$imageSliderUL.css(cssOffsetObject);
		}
	}


}



/** WEBPACK FOOTER **
 ** ./modules/carousel.js
 **/